import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WelcomeInAppPage } from './welcome-in-app';
import { InAppService } from "../../services/in-app-service/in-app-service";

@NgModule({
  declarations: [WelcomeInAppPage],
  providers: [InAppService],
  imports: [IonicPageModule.forChild(WelcomeInAppPage)],
})
export class WelcomeInAppPageModule {}



// WEBPACK FOOTER //
// ./src/modules/core/pages/welcome-in-app/welcome-in-app.module.ts